import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

import { bem } from 'helpers/class-name';
import LINKS from 'constants/links';
import { reactHookFormPropTypes } from 'constants/propTypes';
import { ICONS } from 'constants/icons';
import SmartToolsSection from './SmartToolsSection';
import RemainingItem from './RemainingItem';

export const messages = defineMessages({
  title: {
    id: 'smart-tools.release-extra-spots.title',
    defaultMessage: 'Release extra spots to ClassPass members before class start time',
  },
  description: {
    id: 'smart-tools.release-extra-spots.description',
    defaultMessage:
      'This feature releases any available spots to ClassPass members, at a set number of hours before class, while still prioritizing your direct members. <a>Learn more</a>',
  },
  settingDetail: {
    id: 'smart-tools.release-extra-spots.setting-detail',
    defaultMessage: 'This setting works with the default SmartSpot algorithm to help boost revenue.',
  },
  peak: {
    id: 'smart-tools.release-extra-spots.peak',
    defaultMessage: 'Release before Peak times',
  },
  peakInfo: {
    id: 'smart-tools.release-extra-spots.peak-info',
    defaultMessage: 'Releasing 6 hours before peak start time is common for studios with similar capacity',
  },
  offPeak: {
    id: 'smart-tools.release-extra-spots.off-peak',
    defaultMessage: 'Release before Off-peak times',
  },
  offPeakInfo: {
    id: 'smart-tools.release-extra-spots.off-peak-info',
    defaultMessage: 'Releasing 12 hours before off-peak start time is common for studios with similar capacity',
  },
});

const { element } = bem('release-extra-spots');

const ReleaseExtraSpots = ({
  control,
  countryCode = 'USA',
  handleLearnMore,
  showSelectOptionPeakTime,
  showSelectOptionOffPeakTime,
}) => {
  return (
    <SmartToolsSection
      title={messages.title}
      description={messages.description}
      settingDetail={messages.settingDetail}
      icon={ICONS.releaseSpotsTime}
      countryCode={countryCode}
      learnMoreLink={LINKS.smartspot.learnMore}
      handleLearnMore={handleLearnMore}
      learnMoreLocation="release_extra">
      <div className={element('content-group')}>
        <RemainingItem
          className={element('remaining-item')}
          control={control}
          label={messages.peak}
          info={messages.peakInfo}
          remainingName="releaseExtraSpotsPeakTime"
          showSelectOption={showSelectOptionPeakTime}
        />
        <RemainingItem
          className={element('remaining-item')}
          control={control}
          label={messages.offPeak}
          info={messages.offPeakInfo}
          remainingName="releaseExtraSpotsOffPeakTime"
          showSelectOption={showSelectOptionOffPeakTime}
        />
      </div>
    </SmartToolsSection>
  );
};

ReleaseExtraSpots.propTypes = {
  control: reactHookFormPropTypes.control.isRequired,
  countryCode: PropTypes.string,
  handleLearnMore: PropTypes.func.isRequired,
  showSelectOptionPeakTime: PropTypes.bool.isRequired,
  showSelectOptionOffPeakTime: PropTypes.bool.isRequired,
};

export default ReleaseExtraSpots;
